/**
 * The Analytics views, in the order the ticket prioritises them (PREC-3047):
 * portfolio → campaign → user → signal source.
 *
 * Tabs are added to `ANALYTICS_TABS` as each view lands, so the strip never shows
 * a tab that opens onto nothing. It stays hidden while only one view exists.
 */
export enum AnalyticsTab {
	OVERVIEW = "overview",
	TOP_CAMPAIGNS = "top-campaigns",
	CAMPAIGN_DEEP_DIVE = "campaign",
	USER_DEEP_DIVE = "user",
	SIGNALS = "signals",
}

export interface AnalyticsTabConfig {
	value: AnalyticsTab;
	/** i18n key under `analytics.tabs.*` */
	labelKey: string;
}

export const ANALYTICS_TABS: AnalyticsTabConfig[] = [
	{ value: AnalyticsTab.OVERVIEW, labelKey: "analytics.tabs.overview" },
	{ value: AnalyticsTab.TOP_CAMPAIGNS, labelKey: "analytics.tabs.topCampaigns" },
	{ value: AnalyticsTab.CAMPAIGN_DEEP_DIVE, labelKey: "analytics.tabs.campaignDeepDive" },
	{ value: AnalyticsTab.USER_DEEP_DIVE, labelKey: "analytics.tabs.userDeepDive" },
	{ value: AnalyticsTab.SIGNALS, labelKey: "analytics.tabs.signals" },
];

/**
 * The overview opens first (PREC-3047): the portfolio question — which list or campaign
 * is worth looking at — comes before the detail of any one of them.
 */
export const DEFAULT_ANALYTICS_TAB = AnalyticsTab.OVERVIEW;
